const TYPE = {
  'application/vnd.ms-excel': 'xls',
  'application/vnd.ms-excel.addin.macroenabled.12': 'xlam',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/msword': 'doc',
  'application/pdf': 'pdf',
  'image/jpeg': 'jpeg',
  'image/jpg': 'jpg',
  'image/png': 'png',
  'application/x-zip-compressed': 'zip',
  'application/xml': 'xml',
};

// Получить из файл Base64
export const getBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
});

export const getFile = (fullBase64, fileName = 'Файл') => {
  const parts = fullBase64.split(',');
  const regex = /:(.+?);/;
  const [options, base64] = parts;
  const type = options.match(regex)[1];
  return new File([base64], `${fileName}.${TYPE[type]}`, { type });
};

export const getFileFromUrl = (url, fileName = 'Файл') => new Promise((resolve, reject) => {
  fetch(url).then(
    (res) => {
      res.blob().then(
        (blob) => {
          resolve(new File([blob], fileName, { type: blob.type }));
        },
        (error) => reject(error),
      );
    },
    (error) => reject(error),
  ).catch((error) => reject(error));
});

export const downloadFile = (file, fileName = 'Файл') => {
  const link = document.createElement('a');
  const fileExtension = TYPE[file.type];
  link.href = URL.createObjectURL(file);
  link.download = `${fileName}.${fileExtension}`;
  link.click();
  link.remove();
};
export const downloadFileFromUrl = async (url, fileName, options) => {
  if (!url) throw new Error('Не указан URL файла');
  const [name] = url.split('/').at(-1).split('.');
  const response = await fetch(url, options).catch((error) => { throw new Error(error); });
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', objectUrl);
  link.setAttribute('download', `${fileName ?? name}${TYPE[blob.type] ? `.${TYPE[blob.type]}` : ''}`);
  link.setAttribute('target', '_blank');
  link.style.display = 'none';
  link.click();
  link.remove();
};
